import { previewSaleRounding } from './saleRounding';

// TEMPORARY POS QUICK FINALIZE:
// Remove this bypass when the normal document/payment confirmation flow is restored.
export const TEMPORARY_POS_QUICK_FINALIZE_ENABLED = true;
export const TEMPORARY_POS_QUICK_FINALIZE_DOCUMENT_TYPE = 'boleta';
export const TEMPORARY_POS_QUICK_FINALIZE_PAYMENT_METHOD = 'efectivo';

export const buildTemporaryPosQuickFinalizeCheckout = (totalAmount, settings) => ({
  saleStatus: 'completed',
  paymentTerm: 'immediate',
  paymentMethod: TEMPORARY_POS_QUICK_FINALIZE_PAYMENT_METHOD,
  checkoutPaymentMethods: [TEMPORARY_POS_QUICK_FINALIZE_PAYMENT_METHOD],
  expectedTotalAmount: previewSaleRounding({
    totalAmount, settings,
    checkoutPaymentMethods: [TEMPORARY_POS_QUICK_FINALIZE_PAYMENT_METHOD],
  }).totalAmount,
});

export const getTemporaryPosQuickFinalizeBalance = (purchase) => {
  const totalAmount = Number(purchase?.totalAmount || 0);
  if (purchase?.balance !== undefined) {
    const balance = Number(purchase.balance || 0);
    return Number.isFinite(balance) ? Math.max(balance, 0) : totalAmount;
  }
  const paidAmount = Number(purchase?.paidAmount || 0);
  return Math.max(totalAmount - paidAmount, 0);
};

export const buildTemporaryPosQuickFinalizePaymentUpdate = (receivedAmount) => ({
  documentType: TEMPORARY_POS_QUICK_FINALIZE_DOCUMENT_TYPE,
  paymentTerm: 'immediate',
  paymentMethod: TEMPORARY_POS_QUICK_FINALIZE_PAYMENT_METHOD,
  isPaid: true,
  detailForPayment: receivedAmount > 0 ? { receivedAmount } : {},
});

export const buildTemporaryPosQuickFinalizeReceiptPath = (branchId, purchaseId) =>
  `/branches/${branchId}/purchases/${purchaseId}/receipt?autoprint=1&temporaryQuickFinalize=1`;
